<template>
    <div>
        <div class="c-chat-button" v-if="!showRadios">
            <ion-button>
                <div class="c-wave">
                    <span class="c-wave__dot"></span>
                    <span class="c-wave__dot"></span>
                    <span class="c-wave__dot"></span>
                </div>
            </ion-button>
        </div>
        <transition-group
            tag="div"
            @before-enter="beforeEnter"
            @enter="enter"
            appear
            :css="false"
            v-else
        >
            <div
                v-for="(radio, index) in radios"
                :key="radio.value"
                class="c-chat-button -animated"
                :class="{ '-checked': radio.value === value }"
                :data-index="index + 1"
            >
                <ion-button @click="emitValue(radio.value)" class="-multiline">
                    <span v-if="!hideRadioValue">{{ radio.value }}</span>
                    <br />
                    <span
                        v-if="radio.description"
                        v-html="radio.description"
                    ></span>
                </ion-button>
            </div>
        </transition-group>
    </div>
</template>

<script>
export default {
    props: {
        radios: {
            type: Array,
            required: true,
        },
        hideRadioValue: {
            type: Boolean,
            required: false,
            default: false,
        },
        value: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            showRadios: false,
        };
    },
    mounted() {
        setTimeout(() => {
            this.showRadios = true;
        }, 1300);
    },
    methods: {
        emitValue(value) {
            this.$emit("input", "");
            this.$nextTick(() => {
                this.$emit("input", value);
            });
        },
        beforeEnter(el) {
            el.style.transform = "scale(0)";
            el.style.transformOrigin = "bottom right";
        },
        enter(el, done) {
            setTimeout(() => {
                el.style.transform = "scale(1.3)";
                setTimeout(() => {
                    el.style.transform = "scale(1)";
                    done();
                }, 300);
            }, el.dataset.index * 300);
        },
    },
};
</script>

<style lang="scss" scoped>
.-animated {
    transition: all 0.3s;
}

.c-wave {
    &__dot {
        display: inline-block;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        margin-right: 4px;
        background: white;
        animation: wave 1.3s linear infinite;

        &:nth-child(2) {
            animation-delay: -1.1s;
        }

        &:nth-child(3) {
            animation-delay: -0.9s;
        }
    }
}

@keyframes wave {
    0%,
    60%,
    100% {
        transform: initial;
    }

    30% {
        transform: translateY(-15px);
    }
}
</style>
